import * as React from 'react';
import { Text, ThemeAlert } from '.';
import { alerttype } from '../services/app.service';

interface Props {
  id?: string;
  value?: string;
  type?: alerttype;
  sx?: any,
  onClose?: () => void;
  children?: React.ReactNode;
}

export interface AlertIContext {
  updateValue?: (value: string, type?: alerttype) => void;
}

export const AlertContext = React.createContext({} as AlertIContext);

export const Alert = (context: unknown, value: string, type: alerttype) => {
  (context as AlertIContext).updateValue?.(value, type);
}

export const Alerts: React.FunctionComponent<Props> = (props) => {
  const [values, setValues] = React.useState<any>([]);
  const [value, setValue] = React.useState('');
  const [type, setType] = React.useState<alerttype>();
  const [length, setLength] = React.useState(0);
  const time = 1000;
  const themeAlert = ThemeAlert(type);

  const updateValue = async(newValue: string, newType?: alerttype) => {
    if (!newValue) return;
    setValue(newValue);
    setType(newType);
    setLength(length + 1);
  }

  React.useEffect(() => {
    const idx = values.length - 1;
    
    //add new alert
    if (value && values.length < length) {
      setValues([...values, {value: value, type: type, themeAlert: themeAlert, play: true} ])
      setValue('');
    }
    
    if (!values.length) return;

    //change play to be false (transition fade out)
    if (values[idx]?.play)
      setTimeout(() => {
        setValues((v: any) => v?.map((d: any, i: number) => {return {...d, play: (i === idx? false : d.play)}}));
      }, time * values.length)

    //delete alert
    else
      setTimeout(() => {    
        setLength((v: number) => v-1);
        setValues((v: any) => v?.filter((d: any, i: number) => i > 0) );
      }, time)
  
  }, [value, values]);

  return (
    <AlertContext.Provider value={{updateValue}}>

      {values?.map?.((d: any, i: number) => {
        return <Text key={i} label={d.value.trim()} textToHtml color={d.themeAlert.color} bgColor={d.themeAlert.bgColor} icon={d.themeAlert.icon} transition='fade' transitionTime={d.play? -time : time} transitionPlay={d.play} sx={{border: 1, borderColor: d.themeAlert.color, width: 'auto', ...props.sx, position: 'fixed', zIndex: 1000, borderRadius: 1, top: 1 + (i*2), right: 1 + (i*20), p: 1, pt: 0.2, pb: 0.2, m: 0.2 }} />      
      })}

      {props.children}
      
    </AlertContext.Provider>
  );
  
}
